/**
 * @fileoverview ページ初期ロード制御
 * @description 全リソース読み込み完了後に状態クラスを付与する
 */

const addLoadedClass = () => {
	window.addEventListener('load', () => {
		document.documentElement.classList.add('is-loaded');
	});
};

addLoadedClass();
